(function () {
  'use strict';

  var SHIPPING_THRESHOLD = 5000;  // $50.00 in cents
  var HAT_THRESHOLD      = 10000; // $100.00 in cents
  var FREE_HAT_PROP      = '_free_hat';
  var FREE_HAT_URL_PROP  = '_hat_url';

  // ============ HOOKTOBER "DOUBLE HOOKUP" (2026-10-02) ============
  // Buy 1 UV shirt, get the 2nd 50% off, every pair. The discount is a native
  // automatic BXGY ("Hooktober Double Hookup"); this script only drives the
  // cart progress bar. While it runs, the bar's second checkpoint is the
  // Double Hookup instead of the free hat, and the FREE HAT IS PAUSED (no
  // modal, and any free hat already in a cart is removed). After
  // HOOKTOBER_ENDS the free hat comes back by itself, so a late teardown
  // fails safe. Kill switch: HOOKTOBER_ENABLED = false.
  var HOOKTOBER_ENABLED = true;
  var HOOKTOBER_ENDS    = new Date('2026-10-31T23:59:59-04:00').getTime();
  function hooktoberActive() { return HOOKTOBER_ENABLED && Date.now() < HOOKTOBER_ENDS; }
  // The 25 products tagged _hooktober (= the hooktober collection the
  // discount uses): UV_PRODUCT_IDS below plus the 5 Salt Line hoodies, which
  // that older list predates. Keep in step with the tag.
  var HOOKTOBER_EXTRA_IDS = [
    10602903372069, 10602903404837, 10602903437605, 10602903503141, 10602903535909
  ];

  // ============ FREE TEE PROMO (buy a UV shirt, get a tee free — 1:1) ============
  var TEE_PROMO_ENABLED  = false; // kill switch: set to true to relaunch the promo (paused 2026-08-22 for the Labor Day / Summer Selldown sale)
  var FREE_TEE_PROP      = '_free_tee';
  var FREE_TEE_URL_PROP  = '_tee_url';

  // Product IDs that earn a free tee (all UV shirts: men's, women's, kids)
  var UV_PRODUCT_IDS = [
    10402856010021, 10402856567077, 10402856075557, 10402856763685, 10402856206629,
    10402856370469, 10402856239397, 9678317977893, 9678321156389, 9678318895397,
    9678320468261, 9678334001445, 9678342848805,
    9678368178469, 9678368702757,
    9678356709669, 9678350942501, 9678355497253, 9678360412453, 9678358774053
  ];

  // Collection pages (by handle) that show the free-tee promo strip above the filter.
  var UV_COLLECTION_HANDLES = ['mens-uv-sun-shirts', 'womens-uv-shirts', 'kids-uv-shirts', 'uv-shirts', 'open-water-collection'];

  // $0 variants on the hidden "Free T-Shirt" product (free-t-shirt-do-not-sell)
  var TEE_CDN = 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/';
  var TEE_DESIGNS = [
    { title: "Men's Tee - Black",           group: "Men's Tees",     productUrl: '/products/the-reel-classic-white-blue',                 image: TEE_CDN + 'ReelClassicMen_sT-ShirtinBlackFront.jpg?v=1732811031',      sizes: [{s:'S',v:52819140182309},{s:'M',v:52819140215077},{s:'L',v:52819140247845},{s:'XL',v:52819140280613},{s:'2XL',v:52819140313381}] },
    { title: "Men's Tee - Mint Green",      group: "Men's Tees",     productUrl: '/products/the-reel-classic-heathered-mint-royal-blue',  image: TEE_CDN + 'ReelClassicMen_sT-ShirtinMintGreenFront.jpg?v=1732811208',  sizes: [{s:'S',v:52819140346149},{s:'M',v:52819140378917},{s:'L',v:52819140411685},{s:'XL',v:52819140444453},{s:'2XL',v:52819140477221}] },
    { title: "Men's Tee - Neon Blue",       group: "Men's Tees",     productUrl: '/products/the-reel-classic-neon-blue-neon-green',       image: TEE_CDN + 'Reel_Classic_Men_s_T-Shirt_in_Neon_Blue_Front.jpg?v=1737472246', sizes: [{s:'S',v:52819140509989},{s:'M',v:52819140542757},{s:'L',v:52819140575525},{s:'XL',v:52819140608293},{s:'2XL',v:52819140641061}] },
    { title: "Men's Tee - Royal Blue",      group: "Men's Tees",     productUrl: '/products/the-reel-classic-royal-blue-neon-yellow',     image: TEE_CDN + 'ReelClassicMen_sT-ShirtinRoyalBlueFront.jpg?v=1732811622',  sizes: [{s:'S',v:52819140673829},{s:'M',v:52819140706597},{s:'L',v:52819140739365},{s:'XL',v:52819140772133},{s:'2XL',v:52819140804901}] },
    { title: "Men's Tee - White",           group: "Men's Tees",     productUrl: '/products/the-reel-classic-heather-mint-royal-blue-copy', image: TEE_CDN + 'ReelClassicMen_sT-ShirtinWhiteFront.jpg?v=1732811789',    sizes: [{s:'S',v:52819140837669},{s:'M',v:52819140870437},{s:'L',v:52819140903205},{s:'XL',v:52819140935973},{s:'2XL',v:52819140968741}] },
    { title: "Men's Tee - Reel Icon White", group: "Men's Tees",     productUrl: '/products/the-reel-icon-white',                         image: TEE_CDN + 'ReelIconMen_sT-ShirtinWhiteFront.jpg?v=1732811995',         sizes: [{s:'S',v:52819141001509},{s:'M',v:52819141034277},{s:'L',v:52819141067045},{s:'XL',v:52819141099813},{s:'2XL',v:52819141132581}] },
    { title: "Women's Tank - White",        group: "Women's Tanks",  productUrl: '/products/womens-white-tank',                           image: TEE_CDN + 'ReelClassicWomen_sTankinWhiteFront.jpg?v=1732812961',       sizes: [{s:'S',v:52819141165349},{s:'M',v:52819141198117},{s:'L',v:52819141230885},{s:'XL',v:52819141263653}] },
    { title: "Women's Tank - Dusty Blue",   group: "Women's Tanks",  productUrl: '/products/womens-blue-tank',                            image: TEE_CDN + 'ReelClassicWomen_sTankinDustyBlueFront.jpg?v=1732812834',   sizes: [{s:'S',v:52819141296421},{s:'M',v:52819141329189},{s:'L',v:52819141361957},{s:'XL',v:52819141394725}] },
    { title: "Kids Tee - Black",            group: "Kids Tees",      productUrl: '/products/the-reel-classic-black-kids',                 image: TEE_CDN + 'ReelClassicKidsT-ShirtinBlackFront.jpg?v=1732814383',       sizes: [{s:'S',v:52819141427493},{s:'M',v:52819141460261},{s:'L',v:52819141493029}] },
    { title: "Kids Tee - Neon Pink",        group: "Kids Tees",      productUrl: '/products/the-reel-classic-pink-kids',                  image: TEE_CDN + 'ReelClassicKidsT-ShirtinNeonPinkFront_19de9177-b84b-4ba7-a00d-a98618d4231d.jpg?v=1732814349', sizes: [{s:'S',v:52819141525797},{s:'M',v:52819141558565},{s:'L',v:52819141591333}] },
    { title: "Kids Tee - White",            group: "Kids Tees",      productUrl: '/products/the-reel-classic-white-kids',                 image: TEE_CDN + 'ReelClassicKidsT-ShirtinWhiteFront.jpg?v=1732814482',       sizes: [{s:'S',v:52819141624101},{s:'M',v:52819141656869},{s:'L',v:52819141689637}] },
    { title: "Kids Tee - Neon Blue",        group: "Kids Tees",      productUrl: '/products/the-reel-classic-neon-blue-kids',             image: TEE_CDN + 'ReelClassicKidsT-ShirtinNeonBlueFront.jpg?v=1732814429',    sizes: [{s:'S',v:52819141722405},{s:'M',v:52819141755173},{s:'L',v:52819141787941}] }
  ];

  // $0-priced variants on the hidden "Free Hat" product.
  // productUrl points to the real hat product page.
  var HATS = [
    { variantId: 52594235343141, title: 'First Wave Performance Hat in Gray',      productUrl: '/products/hookster-first-wave-performance-trucker-hat-black-copy',  image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/FirstWavePerformanceHatinGrayFront.jpg?v=1734789659' },
    { variantId: 52594235375909, title: 'First Wave Performance Hat in Black',     productUrl: '/products/hookster-first-wave-trucker-hat-black',                    image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/FirstWavePerformanceHatinBlackFront.jpg?v=1734789630' },
    { variantId: 52594235408677, title: 'Statement Performance Hat in Slate',      productUrl: '/products/hookster-essential-performance-trucker-hat-seafoam',       image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/StatementPerformanceHatinSlateFront.jpg?v=1735056297' },
    { variantId: 52594235441445, title: 'First Wave Trucker Hat in Black Heather', productUrl: '/products/hookster-first-wave-trucker-hat-black-heather',            image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/FirstWaveTruckerHatinBlackHeatherFront.jpg?v=1735056044' },
    { variantId: 52594235474213, title: 'First Wave Trucker Hat in Seafoam',       productUrl: '/products/hookster-first-wave-trucker-hat-seafoam',                  image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/FirstWaveTruckerHatinSeafoamFront.jpg?v=1735056135' },
    { variantId: 52594235506981, title: 'First Wave Trucker Hat in Black',         productUrl: '/products/hookster-essential-trucker-hat-black-blue',               image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/FirstWaveTruckerHatinBlackFront.jpg?v=1735056000' },
    { variantId: 52594235539749, title: 'First Wave Trucker Hat in Stone',         productUrl: '/products/hookster-first-wave-trucker-hat-stone',                   image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/FirstWaveTruckerHatinStoneFront.jpg?v=1735056175' },
    { variantId: 52594235572517, title: 'Statement Performance Hat in Black',      productUrl: '/products/hookster-statement-performance-hat-black-blue',           image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/StatementPerformanceHatinBlackFront.jpg?v=1735056220' },
    { variantId: 52594235605285, title: 'Essential Trucker Hat in Black & Tan',   productUrl: '/products/hookster-essential-trucker-hat-black-2',                  image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/EssentialTruckerHatinBlack_TanFront.jpg?v=1734789537' },
    { variantId: 52594235638053, title: 'Statement Performance Hat in Seafoam',    productUrl: '/products/hookster-statement-performance-hat-seafoam',              image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/StatementPerformanceHatinSeafoamFront.jpg?v=1735056256' },
    { variantId: 52594235670821, title: 'First Wave Trucker Hat in Gray Heather',  productUrl: '/products/hookster-first-wave-trucker-hat-gray-heather',            image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/FirstWaveTruckerHatinGrayHeatherFront.jpg?v=1735056082' },
    { variantId: 52594235703589, title: 'Statement Trucker Hat in Blue Camo',      productUrl: '/products/hookster-statement-trucker-blue-camo',                    image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/StatementTruckerHatinBlueCamoFront.jpg?v=1734789713' },
    { variantId: 52594235736357, title: 'Essential Trucker Hat in Green Camo',    productUrl: '/products/hookster-essential-trucker-hat-green-camo',               image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/EssentialTruckerHatinGreenCamoFront.jpg?v=1734789570' },
    { variantId: 52594235769125, title: 'Essential Trucker Hat in Black & Blue',  productUrl: '/products/hookster-essential-trucker-hat-green-camo-copy',          image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/EssentialTruckerHatinBlack_BlueFront.jpg?v=1734789493' },
    { variantId: 52594235801893, title: 'Essential Trucker Hat in Stone & Blue',  productUrl: '/products/hookster-essential-trucker-hat-black',                    image: 'https://cdn.shopify.com/s/files/1/0772/6920/5285/files/EssentialTruckerHatinStone_BlueFront.jpg?v=1734789458' }
  ];

  var isUpdating = false;
  var hatJustAdded = false;
  var teeBusy = false;
  var teePruning = false;
  var lastHatEligible = false;

  // --- Utilities ---

  function debounce(fn, ms) {
    var timer;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  // --- Cart API ---

  // Shopify's bot protection can answer cart endpoints with an HTML challenge
  // page instead of JSON — surface that as an error instead of crashing later.
  function safeJson(r) {
    return r.text().then(function (t) {
      try { return JSON.parse(t); } catch (e) { throw new Error('cart-response-not-json'); }
    });
  }

  function cartPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(safeJson);
  }

  function getCart() {
    return fetch('/cart.js').then(safeJson);
  }

  function addToCart(variantId, properties) {
    return cartPost(theme.routes.cartAdd, { id: variantId, quantity: 1, properties: properties })
      .then(function (res) {
        // /cart/add.js reports failures as JSON: { status: 422, description: ... }
        if (res && res.status && !res.id) throw new Error('add-failed');
        return res;
      });
  }

  // One automatic retry after a short pause absorbs transient rejections.
  function addToCartWithRetry(variantId, properties) {
    return addToCart(variantId, properties).catch(function () {
      return new Promise(function (resolve) { setTimeout(resolve, 1800); })
        .then(function () { return addToCart(variantId, properties); });
    });
  }

  function removeCartItem(itemKey) {
    return cartPost(theme.routes.cartChange, { id: itemKey, quantity: 0 });
  }

  function setCartItemQty(itemKey, qty) {
    return cartPost(theme.routes.cartChange, { id: itemKey, quantity: qty });
  }

  // --- Impulse cart refresh ---

  function refreshImpulseCart(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:build',   { bubbles: true, detail: { cart: cart } }));
    if (window.theme && window.theme.cart && typeof window.theme.cart.getCartProductMarkup === 'function') {
      window.theme.cart.getCartProductMarkup();
    }
  }

  function restoreDrawerState() {
    function open() {
      document.dispatchEvent(new CustomEvent('drawerOpen', {
        bubbles: true,
        detail: { id: 'CartDrawer' }
      }));
    }
    setTimeout(open, 300);
    setTimeout(open, 700);
  }

  // Fix links on free gift cart items so clicking image/title goes to the real product page.
  function fixFreeGiftCartLinks() {
    setTimeout(function () {
      var products = document.querySelector('[data-products]');
      if (!products) return;

      var anchors = products.querySelectorAll('a[href*="free-hat"], a[href*="free-t-shirt"]');
      anchors.forEach(function (anchor) {
        var isTee = anchor.href.indexOf('free-t-shirt') !== -1;
        var container = anchor.closest('[data-product-id], [data-variant-id], li, .ajaxcart__row');
        var realUrl = null;

        if (container) {
          var titleEl = container.querySelector('a, .ajaxcart__product-name, .cart-item__name');
          var titleText = titleEl ? titleEl.textContent.trim() : '';
          if (isTee) {
            var variantText = container.textContent;
            for (var t = 0; t < TEE_DESIGNS.length; t++) {
              if (variantText.indexOf(TEE_DESIGNS[t].title) !== -1) { realUrl = TEE_DESIGNS[t].productUrl; break; }
            }
          } else {
            for (var i = 0; i < HATS.length; i++) {
              if (HATS[i].title === titleText) { realUrl = HATS[i].productUrl; break; }
            }
          }
        }

        if (!realUrl) {
          var hrefVariantMatch = anchor.href.match(/variant=(\d+)/);
          if (hrefVariantMatch) {
            var vid = parseInt(hrefVariantMatch[1], 10);
            for (var j = 0; j < HATS.length; j++) {
              if (HATS[j].variantId === vid) { realUrl = HATS[j].productUrl; break; }
            }
            if (!realUrl) {
              for (var d = 0; d < TEE_DESIGNS.length; d++) {
                for (var sz = 0; sz < TEE_DESIGNS[d].sizes.length; sz++) {
                  if (TEE_DESIGNS[d].sizes[sz].v === vid) { realUrl = TEE_DESIGNS[d].productUrl; break; }
                }
                if (realUrl) break;
              }
            }
          }
        }

        if (realUrl) {
          anchor.href = realUrl;
        } else {
          anchor.addEventListener('click', function (e) { e.preventDefault(); });
        }
      });

      // Bold the free gift titles.
      var allEls = products.querySelectorAll('a, span, div, p');
      allEls.forEach(function (el) {
        if (el.children.length === 0) {
          var txt = el.textContent.trim();
          if (txt === 'Free Hat' || txt === 'Free T-Shirt') {
            el.style.fontWeight = 'bold';
          }
        }
      });
    }, 800);
  }

  // --- Money formatting ---

  function formatMoney(cents) {
    var dollars = cents / 100;
    return '$' + (Math.round(dollars) === dollars ? dollars.toString() : dollars.toFixed(2));
  }

  // --- Progress Bar ---

  // Double Hookup state for the bar: how many eligible UV shirts are in the
  // cart and how much the discount has taken off them.
  function hooktoberState(cart) {
    var shirts = 0, saved = 0;
    cart.items.forEach(function (item) {
      if (item.properties && (item.properties[FREE_HAT_PROP] === 'true' || item.properties[FREE_TEE_PROP] === 'true')) return;
      if (UV_PRODUCT_IDS.indexOf(item.product_id) === -1 && HOOKTOBER_EXTRA_IDS.indexOf(item.product_id) === -1) return;
      shirts += item.quantity;
      saved += Math.max(0, (item.original_line_price || 0) - (item.final_line_price || 0));
    });
    return { shirts: shirts, saved: saved };
  }

  function updateHooktoberBar(totalCents, hk) {
    requestAnimationFrame(function () {
      var fill = document.getElementById('hat-upsell-fill');
      var msg  = document.getElementById('hat-upsell-message');
      var dotS = document.getElementById('hat-milestone-shipping');
      var dotH = document.getElementById('hat-milestone-hat');
      var lblS = document.getElementById('hat-label-shipping');
      var lblH = document.getElementById('hat-label-hat');
      if (!fill || !msg) return;
      if (lblH) lblH.textContent = '\uD83C\uDFA3 Double Hookup';

      // First half of the bar is dollars toward free shipping, second half
      // fills when the second UV shirt goes in.
      var shippingUnlocked = totalCents >= SHIPPING_THRESHOLD;
      var hookupUnlocked   = hk.shirts >= 2;
      var pct = Math.min(totalCents / SHIPPING_THRESHOLD, 1) * 50 + (hookupUnlocked ? 50 : 0);
      fill.style.width = Math.round(pct) + '%';

      [dotS, lblS].forEach(function (el) { el && el.classList.toggle('is-unlocked', shippingUnlocked); });
      [dotH, lblH].forEach(function (el) { el && el.classList.toggle('is-unlocked', hookupUnlocked); });

      var shipGap = formatMoney(SHIPPING_THRESHOLD - totalCents);
      var savedTxt = hk.saved > 0 ? ' You saved ' + formatMoney(hk.saved) + '.' : '';
      var text;
      if (hk.shirts >= 2) {
        var pairs = Math.floor(hk.shirts / 2);
        text = (pairs >= 2 ? 'Double Hookup x' + pairs + '!' : 'Double Hookup!') + savedTxt;
        if (hk.shirts % 2 === 1) text += ' Add one more UV shirt and it\'s 50% off too.';
        if (!shippingUnlocked) text += ' Spend ' + shipGap + ' more for free shipping.';
      } else if (hk.shirts === 1) {
        text = shippingUnlocked
          ? 'Free shipping unlocked! Add another UV shirt for 50% off.'
          : 'Spend ' + shipGap + ' more for free shipping, or add another UV shirt for 50% off.';
      } else {
        text = shippingUnlocked
          ? 'Free shipping unlocked! Buy 2 UV shirts and the 2nd is 50% off.'
          : 'Spend ' + shipGap + ' more to unlock free shipping';
      }
      msg.textContent = text;
    });
  }

  function updateProgressBar(qualifyingCents, hasFreeHat) {
    requestAnimationFrame(function () {
      var fill = document.getElementById('hat-upsell-fill');
      var msg  = document.getElementById('hat-upsell-message');
      var dotS = document.getElementById('hat-milestone-shipping');
      var dotH = document.getElementById('hat-milestone-hat');
      var lblS = document.getElementById('hat-label-shipping');
      var lblH = document.getElementById('hat-label-hat');
      if (!fill || !msg) return;
      if (lblH) lblH.textContent = '\uD83E\uDDE2 Free Hat';

      var pct = Math.min(Math.round((qualifyingCents / HAT_THRESHOLD) * 100), 100);
      fill.style.width = pct + '%';

      var shippingUnlocked = qualifyingCents >= SHIPPING_THRESHOLD;
      var hatUnlocked      = qualifyingCents >= HAT_THRESHOLD;

      [dotS, lblS].forEach(function (el) { el && el.classList.toggle('is-unlocked', shippingUnlocked); });
      [dotH, lblH].forEach(function (el) { el && el.classList.toggle('is-unlocked', hatUnlocked); });

      if (hatUnlocked) {
        msg.textContent = hasFreeHat
          ? 'Your free hat has been added to your cart!'
          : 'You\'ve unlocked a FREE hat! Choose one below.';
      } else if (shippingUnlocked) {
        msg.textContent = 'Free shipping unlocked! Add ' + formatMoney(HAT_THRESHOLD - qualifyingCents) + ' more for a FREE hat.';
      } else {
        msg.textContent = 'Spend ' + formatMoney(SHIPPING_THRESHOLD - qualifyingCents) + ' more to unlock free shipping';
      }
    });
  }

  // --- Hat Modal ---

  function resetHatButtons() {
    var overlay = document.getElementById('hat-picker-overlay');
    if (!overlay) return;
    overlay.querySelectorAll('.hat-picker-modal__card-btn').forEach(function (b) {
      b.disabled = false;
      b.classList.remove('is-loading');
      b.textContent = 'Select';
    });
  }

  function hatModalOpen() {
    var o = document.getElementById('hat-picker-overlay');
    return !!(o && o.classList.contains('is-open'));
  }

  function teeModalOpen() {
    var o = document.getElementById('tee-picker-overlay');
    return !!(o && o.classList.contains('is-open'));
  }

  function openModal() {
    var overlay = document.getElementById('hat-picker-overlay');
    if (!overlay) return;
    if (teeModalOpen()) return; // tee picker has the stage; hat opens when it closes
    resetHatButtons();
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    var closeBtn = overlay.querySelector('.hat-picker-modal__close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function closeModal() {
    var overlay = document.getElementById('hat-picker-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
  }

  function maybeOpenHatModalFromState() {
    if (lastHatEligible && !hatJustAdded && !hooktoberActive()) {
      setTimeout(openModal, 200);
    }
  }

  // --- Tee Modal ---

  var lastTeeState = { earned: 0, claimed: 0 };

  function updateTeeCounter() {
    var el = document.getElementById('tee-picker-counter');
    if (!el) return;
    var remaining = Math.max(0, lastTeeState.earned - lastTeeState.claimed);
    if (remaining === 0) {
      el.textContent = 'All free tees claimed!';
    } else if (lastTeeState.earned === 1) {
      el.textContent = 'You earned a free tee with your UV shirt - pick any one below!';
    } else {
      el.textContent = 'You earned ' + lastTeeState.earned + ' free tees (1 per UV shirt) - ' + remaining + ' left to pick!';
    }
  }

  function openTeeModal() {
    var overlay = document.getElementById('tee-picker-overlay');
    if (!overlay) return;
    if (hatModalOpen()) closeModal(); // tee picker gets the stage first
    updateTeeCounter();
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
  }

  function closeTeeModal() {
    var overlay = document.getElementById('tee-picker-overlay');
    if (!overlay) return;
    if (!overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    // Tee picker is done — if a free hat is waiting, it takes the stage next.
    maybeOpenHatModalFromState();
  }

  function failButton(btn, isBusyFlagTee) {
    if (isBusyFlagTee) teeBusy = false; else hatJustAdded = false;
    btn.disabled = false;
    btn.classList.remove('is-loading');
    btn.textContent = 'Try again';
  }

  function selectTee(designIndex, btn) {
    if (teeBusy) return;
    var design = TEE_DESIGNS[designIndex];
    if (!design) return;
    var card = btn.closest('.hat-picker-modal__card');
    var sel = card.querySelector('.tee-size-select');
    var variantId = parseInt(sel.value, 10);
    if (!variantId) return;

    teeBusy = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding...';

    var props = {};
    props[FREE_TEE_PROP] = 'true';
    props[FREE_TEE_URL_PROP] = design.productUrl;

    addToCartWithRetry(variantId, props)
      .then(function () { return getCart(); })
      .then(function (cart) {
        teeBusy = false;
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.textContent = 'Select';

        var counts = computeTeeState(cart);
        lastTeeState = counts;
        updateTeeCounter();
        refreshImpulseCart(cart);
        fixFreeGiftCartLinks();

        if (counts.claimed >= counts.earned) {
          closeTeeModal();
          if (!hatModalOpen()) restoreDrawerState();
        }
      })
      .catch(function () {
        failButton(btn, true);
      });
  }

  function computeTeeState(cart) {
    var earned = 0, claimed = 0;
    cart.items.forEach(function (item) {
      if (UV_PRODUCT_IDS.indexOf(item.product_id) !== -1) earned += item.quantity;
      if (item.properties && item.properties[FREE_TEE_PROP] === 'true') claimed += item.quantity;
    });
    return { earned: earned, claimed: claimed };
  }

  function pruneExcessTees(cart, excess) {
    if (teePruning) return;
    var teeLines = cart.items.filter(function (item) {
      return item.properties && item.properties[FREE_TEE_PROP] === 'true';
    });
    if (!teeLines.length) return;
    teePruning = true;
    var line = teeLines[teeLines.length - 1];
    var newQty = Math.max(0, line.quantity - excess);
    setCartItemQty(line.key, newQty)
      .then(function () { return getCart(); })
      .then(function (updated) {
        teePruning = false;
        refreshImpulseCart(updated);
        processCart(updated); // converge if still over-claimed across multiple lines
      })
      .catch(function () { teePruning = false; });
  }

  // --- Core logic ---

  function processCart(cart) {
    var freeHatItems = cart.items.filter(function (item) {
      return item.properties && item.properties[FREE_HAT_PROP] === 'true';
    });

    var freeHatTotal = freeHatItems.reduce(function (sum, item) {
      return sum + item.final_line_price;
    }, 0);

    var qualifyingTotal = cart.total_price - freeHatTotal;
    var hasFreeHat = freeHatItems.length > 0;
    var hooktober = hooktoberActive();

    if (hooktober) {
      // Free hat paused: never offer it, and take back any that is already
      // in a cart (e.g. added before the promo started).
      lastHatEligible = false;
      if (hasFreeHat) {
        Promise.all(freeHatItems.map(function (item) { return removeCartItem(item.key); }))
          .then(function () { return getCart(); })
          .then(function (updatedCart) {
            refreshImpulseCart(updatedCart);
            updateHooktoberBar(updatedCart.total_price, hooktoberState(updatedCart));
          })
          .catch(function () {});
      }
      if (hatModalOpen()) closeModal();
      updateHooktoberBar(qualifyingTotal, hooktoberState(cart));
    } else {
      lastHatEligible = qualifyingTotal >= HAT_THRESHOLD && !hasFreeHat;
      updateProgressBar(qualifyingTotal, hasFreeHat);
    }

    // --- Free tee promo (1 free tee per UV shirt) ---
    var teeState = { earned: 0, claimed: 0 };
    if (TEE_PROMO_ENABLED) {
      teeState = computeTeeState(cart);
      lastTeeState = teeState;
      if (teeModalOpen()) updateTeeCounter();
      if (teeState.claimed > teeState.earned) {
        pruneExcessTees(cart, teeState.claimed - teeState.earned);
      }
    }

    // Auto-remove the free hat if the cart drops below the threshold.
    if (!hooktober && qualifyingTotal < HAT_THRESHOLD && hasFreeHat) {
      var removePromises = freeHatItems.map(function (item) {
        return removeCartItem(item.key);
      });
      Promise.all(removePromises)
        .then(function () { return getCart(); })
        .then(function (updatedCart) {
          refreshImpulseCart(updatedCart);
          updateProgressBar(updatedCart.total_price, false);
        })
        .catch(function () {});
    }

    // One modal at a time — the tee picker goes first, then the hat.
    var teesUnclaimed = TEE_PROMO_ENABLED && teeState.claimed < teeState.earned;
    if (teesUnclaimed && !teeBusy && !teePruning) {
      openTeeModal();
    } else if (TEE_PROMO_ENABLED && teeState.earned > 0 && teeState.claimed >= teeState.earned && teeModalOpen()) {
      closeTeeModal(); // hands the stage to the hat modal if one is waiting
    } else if (!teesUnclaimed && lastHatEligible && !hatJustAdded) {
      openModal();
    }

    if (hasFreeHat || teeState.claimed > 0) fixFreeGiftCartLinks();
  }

  var onCartChange = debounce(function () {
    if (isUpdating) return;
    isUpdating = true;
    getCart()
      .then(processCart)
      .then(function () { isUpdating = false; })
      .catch(function () { isUpdating = false; });
  }, 900);

  // --- Build hat modal DOM ---

  function buildModal() {
    if (document.getElementById('hat-picker-overlay')) return;

    var hatCards = HATS.map(function (hat) {
      return '<div class="hat-picker-modal__card">' +
        '<div class="hat-picker-modal__card-img-wrap">' +
          '<img class="hat-picker-modal__card-img" src="' + hat.image + '" alt="' + hat.title + '" loading="lazy" width="300" height="300">' +
        '</div>' +
        '<div class="hat-picker-modal__card-body">' +
          '<p class="hat-picker-modal__card-free">FREE</p>' +
          '<p class="hat-picker-modal__card-name">' + hat.title + '</p>' +
          '<button class="hat-picker-modal__card-btn" type="button" data-variant-id="' + hat.variantId + '">Select</button>' +
        '</div>' +
      '</div>';
    }).join('');

    var overlay = document.createElement('div');
    overlay.id = 'hat-picker-overlay';
    overlay.className = 'hat-picker-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<div class="hat-picker-overlay__backdrop"></div>' +
      '<div class="hat-picker-modal" role="dialog" aria-modal="true" aria-labelledby="hat-picker-title">' +
        '<div class="hat-picker-modal__head">' +
          '<div>' +
            '<span class="hat-picker-modal__badge">Free Gift Unlocked</span>' +
            '<h2 class="hat-picker-modal__title" id="hat-picker-title">Choose Your Free Hat!</h2>' +
            '<p class="hat-picker-modal__subtitle">You earned it - pick any hat on us!</p>' +
          '</div>' +
          '<button class="hat-picker-modal__close" type="button" aria-label="Close">' +
            '<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="hat-picker-modal__body">' +
          '<div class="hat-picker-modal__grid">' + hatCards + '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) { e.stopPropagation(); });
    overlay.querySelector('.hat-picker-overlay__backdrop').addEventListener('click', function (e) { e.stopPropagation(); closeModal(); });
    overlay.querySelector('.hat-picker-modal__close').addEventListener('click', function (e) { e.stopPropagation(); closeModal(); });

    overlay.querySelectorAll('.hat-picker-modal__card-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        selectHat(parseInt(btn.dataset.variantId, 10), btn);
      });
    });

    overlay.querySelectorAll('.hat-picker-modal__card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!e.target.closest('.hat-picker-modal__card-btn')) {
          card.querySelector('.hat-picker-modal__card-btn').click();
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeModal(); closeTeeModal(); }
    });
  }

  // --- Build tee modal DOM ---

  function buildTeeModal() {
    if (!TEE_PROMO_ENABLED) return;
    if (document.getElementById('tee-picker-overlay')) return;

    var groups = ["Men's Tees", "Women's Tanks", "Kids Tees"];
    var body = '';
    groups.forEach(function (groupName) {
      var cards = '';
      TEE_DESIGNS.forEach(function (design, idx) {
        if (design.group !== groupName) return;
        var opts = design.sizes.map(function (o) {
          return '<option value="' + o.v + '">' + o.s + '</option>';
        }).join('');
        cards +=
          '<div class="hat-picker-modal__card tee-card">' +
            '<div class="hat-picker-modal__card-img-wrap">' +
              '<img class="hat-picker-modal__card-img" src="' + design.image + '" alt="' + design.title + '" loading="lazy" width="300" height="300">' +
            '</div>' +
            '<div class="hat-picker-modal__card-body">' +
              '<p class="hat-picker-modal__card-free">FREE</p>' +
              '<p class="hat-picker-modal__card-name">' + design.title + '</p>' +
              '<select class="tee-size-select" aria-label="Size">' + opts + '</select>' +
              '<button class="hat-picker-modal__card-btn tee-select-btn" type="button" data-design-index="' + idx + '">Select</button>' +
            '</div>' +
          '</div>';
      });
      if (cards) {
        body += '<p class="hat-picker-modal__section-title">' + groupName + '</p>' +
                '<div class="hat-picker-modal__grid">' + cards + '</div>';
      }
    });

    var overlay = document.createElement('div');
    overlay.id = 'tee-picker-overlay';
    overlay.className = 'hat-picker-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<div class="hat-picker-overlay__backdrop"></div>' +
      '<div class="hat-picker-modal" role="dialog" aria-modal="true" aria-labelledby="tee-picker-title">' +
        '<div class="hat-picker-modal__head">' +
          '<div>' +
            '<span class="hat-picker-modal__badge">Free T-Shirt Promo</span>' +
            '<h2 class="hat-picker-modal__title" id="tee-picker-title">Choose Your Free T-Shirt!</h2>' +
            '<p class="hat-picker-modal__subtitle" id="tee-picker-counter">You earned a free tee with your UV shirt - pick any one below!</p>' +
          '</div>' +
          '<button class="hat-picker-modal__close" type="button" aria-label="Close">' +
            '<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="hat-picker-modal__body">' + body + '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) { e.stopPropagation(); });
    overlay.querySelector('.hat-picker-overlay__backdrop').addEventListener('click', function (e) { e.stopPropagation(); closeTeeModal(); });
    overlay.querySelector('.hat-picker-modal__close').addEventListener('click', function (e) { e.stopPropagation(); closeTeeModal(); });

    overlay.querySelectorAll('.tee-select-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        selectTee(parseInt(btn.dataset.designIndex, 10), btn);
      });
    });
  }

  // --- Product-page promo banner ---

  function injectTeePromoBanner() {
    if (!TEE_PROMO_ENABLED) return;
    if (document.querySelector('.tee-promo-banner')) return;
    var meta = (window.meta && window.meta.product) ||
               (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product);
    if (!meta || UV_PRODUCT_IDS.indexOf(meta.id) === -1) return;
    var anchor = document.querySelector('.product-block--price');
    if (!anchor || !anchor.parentNode) return;
    var banner = document.createElement('div');
    banner.className = 'tee-promo-banner';
    banner.innerHTML =
      '<span class="tee-promo-banner__icon" aria-hidden="true">🎁</span>' +
      '<span><strong>FREE T-SHIRT WITH THIS SHIRT!</strong> Buy any UV shirt, get a free tee of your choice! Pick yours in the cart.</span>';
    anchor.parentNode.insertBefore(banner, anchor.nextSibling);
  }

  // --- Collection-page promo strip (UV collections only, above the filter) ---

  function injectCollectionPromoStrip() {
    if (!TEE_PROMO_ENABLED) return;
    if (document.querySelector('.tee-collection-strip')) return;
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    if (!m || UV_COLLECTION_HANDLES.indexOf(m[1]) === -1) return;
    var section = document.querySelector('[id*="main-collection"]');
    if (!section || !section.parentNode) return;
    var wrap = document.createElement('div');
    wrap.className = 'page-width tee-collection-strip-wrap';
    var strip = document.createElement('div');
    strip.className = 'tee-collection-strip';
    strip.innerHTML =
      '<span class="tee-collection-strip__icon" aria-hidden="true">🎁</span>' +
      '<span><strong>FREE T-SHIRT with any UV shirt!</strong> Pick yours in the cart.</span>';
    wrap.appendChild(strip);
    section.parentNode.insertBefore(wrap, section);
  }

  // --- Hat selection ---

  function selectHat(variantId, btn) {
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding...';

    hatJustAdded = true;
    clearTimeout(selectHat._cooldownTimer);
    selectHat._cooldownTimer = setTimeout(function () { hatJustAdded = false; }, 4000);

    var hatData = null;
    for (var i = 0; i < HATS.length; i++) {
      if (HATS[i].variantId === variantId) { hatData = HATS[i]; break; }
    }

    var props = {};
    props[FREE_HAT_PROP] = 'true';
    if (hatData) props[FREE_HAT_URL_PROP] = hatData.productUrl;

    addToCartWithRetry(variantId, props)
      .then(function () { return getCart(); })
      .then(function (cart) {
        closeModal();
        resetHatButtons();
        refreshImpulseCart(cart);
        processCart(cart);
        restoreDrawerState();
        fixFreeGiftCartLinks();
      })
      .catch(function () {
        failButton(btn, false);
      });
  }

  // --- Setup observers ---

  function attachSubtotalObserver() {
    var subtotalEl = document.querySelector('[data-subtotal]');
    if (subtotalEl && !subtotalEl._hatObserver) {
      var observer = new MutationObserver(onCartChange);
      observer.observe(subtotalEl, { childList: true, subtree: true, characterData: true });
      subtotalEl._hatObserver = true;
    }
  }

  function setup() {
    attachSubtotalObserver();
    injectTeePromoBanner();
    injectCollectionPromoStrip();

    document.addEventListener('cart:updated', debounce(function (e) {
      if (e.detail && e.detail.cart && !e.detail._fromHatUpsell) {
        processCart(e.detail.cart);
      }
    }, 900));

    onCartChange();
  }

  buildModal();
  buildTeeModal();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

})();